import classNames from 'classnames';

import './style.scss';
import { ComponentProps } from 'react';

type ActionButtonProps = {
  onClick: () => void;
  iconName: string;
};

type FileCardProps = {
  fileName: string;
  actionButton?: ActionButtonProps;
  variant?: 'default' | 'input';
} & Omit<ComponentProps<'div'>, 'children'>;

const FileCard = ({ fileName, actionButton, className, variant = 'default', ...props }: FileCardProps) => {
  const isDefaultVariant = variant === 'default';
  return (
    <div className={classNames('file-card card border', className)} title={fileName} {...props}>
      <div
        className={classNames('file-upload p-1 ps-12px gap-2 flex-x', {
          'bg-white bg-opacity-20': !isDefaultVariant,
          'bg-secondary bg-opacity-10': isDefaultVariant,
        })}
      >
        <em className="icon icon-outlined fs-2 lh-1">email</em>
        <span className="file-upload-title d-block text-truncate fw-medium fs-5">{fileName}</span>
        <button
          className="btn btn-flat-secondary btn-icon"
          onClick={actionButton?.onClick}
          disabled={!actionButton}
          aria-hidden={!actionButton}
        >
          <em className="icon">{actionButton?.iconName}</em>
        </button>
      </div>
    </div>
  );
};

export default FileCard;
